import { render } from "./ZapiImageManager.vue?vue&type=template&id=94f679c6&scoped=true"
import script from "./ZapiImageManager.vue?vue&type=script&lang=js"
export * from "./ZapiImageManager.vue?vue&type=script&lang=js"

import "./ZapiImageManager.vue?vue&type=style&index=0&id=94f679c6&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94f679c6"]])

export default __exports__